import { useParams, Navigate } from "react-router-dom";
import ServiceLanePage from "@/pages/services/ServiceLanePage";
import { LANES } from "@/pages/services/laneData";

export default function ServiceLaneRoute() {
  const { lane } = useParams();
  const data = LANES[lane];
  if (!data) return <Navigate to="/services" replace />;
  return <ServiceLanePage lane={data} />;
}
